
import React, { Component, Fragment } from 'react'
import CenterElement from '../../activity/activityComponent/CenterElement'
import $ from "jquery"
import ConnectLine from '../model/ConnectLine'
import TargetItem from '../model/TargetItem'
import SourceItem from '../model/SourceItem'

class TargetItemUI extends Component {

    state = {
        v: "hidden"
    }
    componentDidUpdate = () => {
        $(".contextsourceItem").each(function (index, element) {
            window.x(element)
        })

    }

    componentDidMount = () => {
        let { targetItem } = this.props
        targetItem.htmlRef = this.targetRef
    }


    render = () => {

        let { targetItem, activity, quizViewer } = this.props

        let { quizViwerModel } = quizViewer.state
        let targetImg = quizViwerModel.imgRes + (targetItem ? targetItem.targetImg : "")

        return (
            <Fragment>
                <div className="myTarget" ref={(e) => this.targetRef = e} onClick={this.handlTargetClick}>
                    {
                        this.getFulltargetItem()
                    }
                </div>
            </Fragment>
        )
    }

    getFulltargetItem = () => {
        let { activity, quizViewer, targetItem } = this.props

        return (
            <div >
                {
                    this.getTargetItemUI(targetItem)
                }
            </div>
        )
    }
    getTargetItemUI = (targetItem) => {
        let { activity, ConnectContainerModel } = this.props

        if (ConnectContainerModel.targetType == activity.ConnectContainerModel.TEXT_TYPE) {
            return this.getTargetItemUITxt(targetItem)
        }
        else {
            return this.getTargetItemUIImgTxt(targetItem)

        }
    }

    getTargetItemUIImgTxt = (targetItem) => {
        let { activity, quizViewer } = this.props
        let { quizViwerModel } = quizViewer.state
        let Img = targetItem.hasExternalUrl ? targetItem.targetImg : (activity.matchingUrl + targetItem.targetImg)

        return (
            <Fragment>
                <div class="card" style={{ marginBottom: "10px", width: "200px" }}>
                    <div class="card-body">
                        <img style={{ width: "100%" }} src={Img} />
                        <div hidden={activity.ConnectContainerModel.targetType == activity.ConnectContainerModel.TEXT_IMG_TYPE}>
                            {/* <EditorContainer onChange={(e) => { targetItem.targetTxt = e.target.getContent() }} content={quizViewer.getTxt(targetItem.targetTxt)} /> */}
                            {targetItem.targetTxt}
                        </div>
                        <i class="pi pi-circle-off" style={{ float: "left" }}></i>

                    </div>
                </div>
            </Fragment>
        )
    }

    getTargetItemUITxt = () => {

        let { targetItem, activity, quizViewer } = this.props
        let { quizViwerModel } = quizViewer.state

        return (
            <Fragment>
                <div class="card" style={{ marginBottom: "10px" }}>
                    <div class="card-body">
                        {targetItem.targetTxt}
                        <i class="pi pi-circle-off" style={{ float: "left" }}></i>
                    </div>
                </div>
            </Fragment>
        )
    }
    handlTargetClick = (e) => {

        let { activity, targetItem, quizViewer } = this.props
        if (activity.currentSelectedSource.sourceIndex != -1) {
            activity.currentSelectedTarget = targetItem;

            let line = new ConnectLine();
            line.lineIndex = activity.lineList.length
            line.sourceItem = activity.currentSelectedSource
            line.targetItem = activity.currentSelectedTarget

            activity.lineList.push(line)

            targetItem.solvedSourceItemList.push(activity.currentSelectedSource)
            quizViewer.setState({})

            activity.currentSelectedSource = new SourceItem()
            activity.currentSelectedTarget = new TargetItem()

        }

    }

    getHtmlRef = () => {
        return this.targetRef
    }
}

export default TargetItemUI